import type { FallbackRender } from '@sentry/nextjs';
import * as Sentry from '@sentry/nextjs';
import { Box } from '@trmediaab/zebra';
import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  showError?: boolean;
}

const getErrorView: FallbackRender = ({ error, componentStack }) => {
  const err =
    error instanceof Error ? error : new Error(`${error}\n${componentStack}`);
  // TODO
  return <Box>{JSON.stringify({ err })}</Box>;
};

const ErrorBoundary = ({ children, showError = true }: ErrorBoundaryProps) => (
  <Sentry.ErrorBoundary fallback={showError ? getErrorView : undefined}>
    {children}
  </Sentry.ErrorBoundary>
);

ErrorBoundary.displayName = 'AppErrorBoundary';

export default ErrorBoundary;
